// src/api/government.js
import client from "./client";

// Get government benefits summary (group-level)
export const getGovernmentBenefitsSummaryApi = async ({ month } = {}) => {
  const params = {};
  if (month) params.month = month;

  const res = await client.get("/government/government-benefits", { params });
  return res.data;
};

// Get government benefits summary (store-level)
export const getGovernmentBenefitsByStoreApi = async ({ group, month }) => {
  return client.get("/government/government-benefits/store", {
    params: { group, month },
  });
};

// Get government benefits summary (personnel-level)
export const getGovernmentBenefitsPersonnelApi = async ({ store, month, mbsMode = "normal" }) => {
  const res = await client.get("/government/government-benefits/personnel", {
    params: { store, month, mbs_mode: mbsMode },
  });
  return res.data;
};

// Export full group summary (per group, all benefits) as file (CSV/XLSX/etc.)
export const exportGovernmentGroupApi = ({ group_id, groupId, month, mbsMode = "normal" }) => {
  const effectiveGroupId = group_id || groupId;

  return client.get("/government/export-group", {
    params: {
      month,
      group_id: effectiveGroupId,
      mbs_mode: mbsMode,
    },
    responseType: "blob",
  });
};

// Export multiple groups into a single Excel file
export const exportGovernmentGroupSelectedApi = ({ month, groupIds, mbsMode = "normal" }) => {
  const group_ids = Array.isArray(groupIds) ? groupIds.join(",") : groupIds;
  return client.get("/government/export-group-selected", {
    params: {
      month,
      group_ids,
      mbs_mode: mbsMode,
    },
    responseType: "blob",
  });
};

// Export full store summary of a given group
export const exportGovernmentStoreApi = async ({ store, month, mbsMode = "normal" }) => {
  return client.get("/government/export-store", {
    params: { store, month, format: "csv", mbs_mode: mbsMode },
    responseType: "blob",
  });
};

// Export a single benefit (sss / pagibig / phic) for a group as file
export const exportGovernmentSingleBenefitApi = async ({
  group,
  month,
  type,
  mbsMode = "normal",
}) => {
  const res = await client.get("/government/export-single-benefit", {
    params: { group, month, type, mbs_mode: mbsMode },
    responseType: "blob",
  });
  return res;
};

